import { render, staticRenderFns } from "./CouponMore.vue?vue&type=template&id=74ef2e21&scoped=true&"
import script from "./CouponMore.vue?vue&type=script&lang=js&"
export * from "./CouponMore.vue?vue&type=script&lang=js&"
import style0 from "./CouponMore.vue?vue&type=style&index=0&id=74ef2e21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ef2e21",
  null
  
)

export default component.exports